import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex--align-center flex--gap-medium" }
const _hoisted_2 = { class: "form__set" }
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "form__icon form__icon--down"
}
const _hoisted_5 = ["id", "onUpdate:modelValue"]
const _hoisted_6 = ["value", "disabled"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " No users found ", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "form__error"
}
const _hoisted_12 = {
  key: 1,
  class: "error-message"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: `Add ${$props.userType}`,
    onCloseModal: $setup.closeModal
  }, {
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (user, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: 'user-' + index
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", {
                for: 'user-' + index,
                class: _normalizeClass(["form__label", { 'invisible': index > 0 }])
              }, _toDisplayString($setup.input_label), 11 /* TEXT, CLASS, PROPS */, _hoisted_3),
              ($setup.filtered_user_list && $setup.filtered_user_list.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("select", {
                      id: 'user-' + index,
                      "onUpdate:modelValue": $event => ((user.value) = $event),
                      class: _normalizeClass(["form__select form-select__stretch", { 'form__select--error': $props.errors[ user.id ] }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filtered_user_list, (available_user) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `submission-${ available_user.value }`,
                          value: available_user.value,
                          disabled: !available_user.value
                        }, _toDisplayString(available_user.label), 9 /* TEXT, PROPS */, _hoisted_6))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 10 /* CLASS, PROPS */, _hoisted_5), [
                      [_vModelSelect, user.value]
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            ]),
            (index > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "icon icon--close mb-16",
                  onClick: $event => ($setup.removeUser( index ))
                }, null, 8 /* PROPS */, _hoisted_10))
              : _createCommentVNode("v-if", true)
          ]),
          ($props.errors[ user.id ])
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", null, _toDisplayString($props.errors[ user.id ]), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */)),
      ($setup.filtered_user_list && $setup.filtered_user_list.length && $setup.can_add_multiple)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "flex flex--align-center flex--gap-small icon icon--add p--small",
            onClick: $setup.addUser
          }, _toDisplayString($setup.add_another_label), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      ($props.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($props.errorMessage), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        disabled: $props.loading || !$setup.filtered_user_list || !$setup.filtered_user_list.length,
        onClick: $setup.closeModal
      }, " Cancel ", 8 /* PROPS */, _hoisted_13),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill", { 'button--loading' : $props.loading }]),
        disabled: $props.loading || !$setup.filtered_user_list || !$setup.filtered_user_list.length,
        onClick: $setup.addSelectedUsersToProject
      }, " Add " + _toDisplayString($props.userType), 11 /* TEXT, CLASS, PROPS */, _hoisted_14)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["heading"]))
}